export const buttonStyles = {
  components: {
    Button: {
      variants: {
        "no-hover": {
          _hover: {
            boxShadow: "none",
          },
        },
        "transparent-with-icon": {
          bg: "transparent",
          fontWeight: "bold",
          borderRadius: "inherit",
          cursor: "pointer",
          _hover: "none",
          _active: {
            bg: "transparent",
            transform: "none",
            borderColor: "transparent",
          },
          _focus: {
            boxShadow: "none",
          },
          _hover: {
            boxShadow: "none",
          },
        },
        brand: {
          bg: "primary.500",
          color: "primary-foreground",
          _hover: {
            bg: "primary.600",
          },
          _active: {
            bg: "primary.700",
          },
          _focus: {
            boxShadow: "0 0 0 2px var(--chakra-colors-primary-500)",
          },
        },
        outlineWhite: {
          bg: "transparent",
          color: "foreground",
          borderColor: "border",
          borderWidth: "1px",
          _hover: {
            bg: "whiteAlpha.100",
          },
          _active: {
            bg: "whiteAlpha.200",
          },
          _focus: "none",
        },
      },
      baseStyle: {
        borderRadius: "12px",
        _focus: {
          boxShadow: "none",
        },
        _active: "none",
      },
    },
  },
};
